import { render, staticRenderFns } from "./MarketplaceContractProps.vue?vue&type=template&id=c29fc5da&scoped=true&"
import script from "./MarketplaceContractProps.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29fc5da",
  null
  
)

export default component.exports